module.exports = __webpack_public_path__ + "static/media/btn_slide_prev.de9e10aa.svg";